module.exports = __webpack_public_path__ + "73edf9197188b70ee4ca971b07a6b688.svg";